export enum Auth0Keys {
    Domain = 'dev-f-65i9gc.eu.auth0.com',
    ClientId = 'M3mTETlyoRjXP0nH5MXvp5v2w1JFYREU',
    CallbackDomain = 'https://loyalty.vapox.co.uk' //'http://localhost:3000'
}